import { Span } from "@goodfill/ui-components";

export const TransferSection: React.FC = () => {
  return (
    <div className="flex w-96">
      <div className="flex flex-col my-1 md:my-2 mx-4 md:mx-8 px-4 md:px-8 gap-4 md:gap-8">
        <div className="flex flex-col w-96">
          <div className="flex items-center justify-between my-2 md:my-4">
            <Span font="semibold" size="lg">
              Transfer
            </Span>
          </div>
        </div>
      </div>
    </div>
  );
};
